export const SET_LOADING = "SET_LOADING";
export const SET_USERINFO = "SET_USERINFO"
